export default __webpack_public_path__ + "static/media/WBTC.d8219479.svg";